const awsmobile = {
    aws_project_region: "us-west-2",
    aws_cognito_identity_pool_id: "us-west-2:705e66f0-e99f-4f01-ab62-09130f292779",
    aws_cognito_region: "us-west-2",
    aws_user_pools_id: "us-west-2_KSIO9zvL0",
    aws_user_pools_web_client_id: "639odqo95jklaotvkmgb9ovje5",
    aws_mobile_analytics_app_id: "e56cf278d55441ebb2ce0e43557c2ec4",
    aws_mobile_analytics_app_region: "us-west-2"
}

export default awsmobile
